<template>
  <!-- Converting footer to use Vuetify components for responsive design -->
  <v-footer class="bg-dark-charcoal" color="dark-charcoal" padless>
    <v-container>
      <v-row class="py-6">
        <!-- Using Vuetify grid system for responsive layout -->
        <v-col cols="12" md="4" class="mb-4 mb-md-0">
          <h4 class="text-h6 font-weight-bold mb-3 text-white text-uppercase">
            Oficina
          </h4>
          <div class="text-grey-lighten-1">
            <v-btn
              variant="text"
              color="grey-lighten-1"
              href="https://maps.app.goo.gl/BgVKuLZgW8SWgKon7"
              target="_blank"
              class="pa-0 justify-start text-body-2 mb-2"
              style="text-transform: none; height: auto; min-width: auto;"
            >
              10 De Octubre 200
            </v-btn>
            <p class="mb-1">CP 4400, Salta Capital</p>
          </div>
        </v-col>

        <v-col cols="12" md="4" class="mb-4 mb-md-0">
          <h4 class="text-h6 font-weight-bold mb-3 text-white text-uppercase">
            Contacto
          </h4>
          <div class="d-flex flex-column ga-2 text-grey-lighten-1">
            <v-btn
              variant="text"
              color="grey-lighten-1"
              href="mailto:estudio@estudiogallopulo.com.ar"
              class="pa-0 justify-start text-body-2 mb-1"
              style="text-transform: none; height: auto; min-width: auto;"
            >
              estudio@estudiogallopulo.com.ar
            </v-btn>
            <v-btn
              variant="text"
              color="grey-lighten-1"
              href="`tel:+5493876203088`"
              class="pa-0 justify-start text-body-2 mb-1"
              style="text-transform: none; height: auto; min-width: auto;"
            >
              387 620-3088
            </v-btn>
          </div>
        </v-col>

        <v-col cols="12" md="4">
          <h4 class="text-h6 font-weight-bold mb-3 text-white text-uppercase">
            Nuestras Redes
          </h4>
          <div class="d-flex flex-column ga-2">
            <!-- Using Vuetify buttons for social media links -->
            <v-btn
              variant="text"
              color="grey-lighten-1"
              href="https://www.instagram.com/estudiogallopulo/"
              target="_blank"
              class="justify-start pa-0"
              style="text-transform: none; height: auto; min-width: auto;"
            >
              <v-icon start size="20">mdi-instagram</v-icon>
              Instagram
            </v-btn>
            <v-btn
              variant="text"
              color="grey-lighten-1"
              href="https://www.facebook.com/estudiogallopulo"
              target="_blank"
              class="justify-start pa-0"
              style="text-transform: none; height: auto; min-width: auto;"
            >
              <v-icon start size="20">mdi-facebook</v-icon>
              Facebook
            </v-btn>
          </div>
        </v-col>
      </v-row>

      <!-- Using Vuetify divider and responsive text -->
      <v-divider class="border-opacity-25"></v-divider>
      
      <v-row class="pt-4">
        <v-col cols="12" class="text-center">
          <p class="text-grey text-body-2 mb-0">
            &copy; 2025 Estudio Gallo Puló. Todos los derechos reservados. 
            Desarrollo por 
            <v-btn
              variant="text"
              color="grey"
              href="https://ia-link.com"
              target="_blank"
              class="pa-0"
              style="text-transform: none; height: auto; min-width: auto; text-decoration: underline;"
            >
              IA-Link
            </v-btn>.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script setup>
// No reactive data needed for footer
</script>

<style scoped>
/* Adding custom styles for dark theme consistency */
.bg-dark-charcoal {
  background-color: var(--color-dark-charcoal) !important;
}
</style>
